<template>
    <div class="new-tag">
        <div>{{ i18n.t('new') }}</div>
    </div>
</template>

<script lang="ts" setup>
    import { i18n } from '@/core/lib/i18n';
</script>

<style lang="scss" scoped>
    .new-tag {
        padding: map-get($spacers, xs) map-get($spacers, sm);
        border-width: 1px;
        border-style: solid;
        border-color: $countBorderColor;
        background-color: $countBgColor;
        border-radius: $countBorderRadius;
        color: $countColor;
        font-size: $fontSize-base;
        font-weight: bold;
    }
</style>
